export const getStatusName = (statuses: TaskStatus[], id: string) => {
  if (!id) {
    return 'No status'
  }

  const status = statuses.find(status => status.id === id)
  return status?.name ?? 'Unknown status'
}

export const getStatusColor = (statuses: TaskStatus[], id: string) => {
  const status = statuses.find(status => status.id === id)
  return `#${status?.colour ?? 'C4C6E7'}`
}
